export default __webpack_public_path__ + "static/annan-b0b07d2bb2d1beb8038627bd45cfaac1.png";